<nav class="navbar" [ngStyle]="{'background-color': onderneming.kleur}"></nav>

<div class="container">
  <div class="min row align-items-end h-100">
    <div class="col d-flex h-100 my-auto mx-auto ">
    <div *ngIf="onderneming.naam != 'Besox'">
      <a [routerLink]="['/',onderneming.naam,'tools']" *ngIf="logoUrl" class="navbar-brand">
        <img class="logo" [src]="logoUrl" [alt]="onderneming.naam">
      </a>
    </div>

    <!-- op aanvraag van besox linkt het logo op sstools naar de website van besox-->
    <div *ngIf="onderneming.naam == 'Besox'">
      <a href="https://www.besox.be/" *ngIf="logoUrl" class="navbar-brand">
        <img class="logo" [src]="logoUrl" [alt]="onderneming.naam">
      </a>
    </div>
     
    </div>
    <div class ="col d-flex h-100 my-auto mx-auto padding ">
      <!-- <div *ngIf="this.authService.isLoggedIn !== true" class="col text-right login">
        <button [routerLink]="['/login']" type="button" class="btn btn-dark">LOGIN
        </button>
      </div> -->
      <div *ngIf="this.authService.isLoggedIn$ | async" class="col text-right login">

       
      
  
        <div class="dropdown">
          <button [routerLink]="['/', onderneming.naam,'tools']" type="button" class="btn mr-3 mobileMarginButton btn-outline-dark">Hoofdpagina
          </button>
          <button class="btn btn-outline-dark dropdown-toggle" type="button" id="dropdownMenu2" aria-haspopup="true"
                  aria-expanded="false" data-toggle="dropdown">
            <i class="fa fa-user-circle-o " aria-hidden="true"></i>
            Mijn profiel
          </button>


          <div class="dropdown-menu" aria-labelledby="dropdownMenu2">

            <button [routerLink]="['/', onderneming.naam,'admin']" type="button" class="dropdown-item">
              Admin Paneel
            </button>
            <button [routerLink]="['/wachtwoord-reset']" type="button" class="dropdown-item">Reset Wachtwoord
            </button>
            <div class="dropdown-divider"></div>
            <button (click)="logout()" type="button" class="dropdown-item">Uitloggen
            </button>
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>

  </div>
</div>
